import { useMemo } from "react";
import { useAppointments } from "./useAppointments";
import useInterval from "./useInterval";
import { getDateTimeDate, itsMeetingTime } from "../utils/timeHelpers";
import { getUpcomingAppointments } from "../utils/reshapData";
import dayjs from "dayjs";

const useEnableJoinBtn = (currentCohort) => {
  const { data: myAppointments } = useAppointments();
  const upcomingMeetingsByDate = useMemo(() => {
    const appointmentByDate = myAppointments
      ? getUpcomingAppointments(
          [...myAppointments].filter((item) => {
            return (
              item.item_type === "cohort" &&
              item.slug === currentCohort?.slug &&
              dayjs(getDateTimeDate(item.start_date)).isSame(
                dayjs().format("YYYY-MM-DD")
              )
            );
          })
        )
      : [];
    return appointmentByDate;
  }, [myAppointments, currentCohort]);

  const tick = useInterval(() => {}, 30000);
  const disableJoinBtn = useMemo(() => {
    return !(
      upcomingMeetingsByDate.length &&
      itsMeetingTime(
        upcomingMeetingsByDate[0]?.start_date,
        upcomingMeetingsByDate[0]?.start_time,
        upcomingMeetingsByDate[0]?.end_time
      )
    );
  }, [upcomingMeetingsByDate, tick]);

  const checkIfIsLive = (cohort) => {
    const upcomingMeetingsByDate_ = myAppointments
      ? getUpcomingAppointments(
          [...myAppointments].filter((item) => {
            return (
              item.slug === cohort?.slug &&
              dayjs(getDateTimeDate(item.start_date)).isSame(
                dayjs().format("YYYY-MM-DD")
              )
            );
          })
        )
      : [];

    const itsTime =
      upcomingMeetingsByDate_.length &&
      itsMeetingTime(
        upcomingMeetingsByDate_[0]?.start_date,
        upcomingMeetingsByDate_[0]?.start_time,
        upcomingMeetingsByDate_[0]?.end_time
      );

    return itsTime;
  };

  const checkIfIsUpcoming = (cohort) => {
    const upcomingMeetingsByDate_ = myAppointments
      ? getUpcomingAppointments(
          [...myAppointments].filter((item) => {
            return (
              item.slug === cohort?.slug &&
              dayjs(`${item.start_date} ${item.start_time}`).isAfter(dayjs())
            );
          })
        )
      : [];

    return upcomingMeetingsByDate_.length > 0;
  };

  return { disableJoinBtn, checkIfIsLive, checkIfIsUpcoming };
};

export default useEnableJoinBtn;
